/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2024 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { FC } from "react";
import { IPatientResponse } from "../../types/patient";
import { PersonCircleXMarkIcon } from "../Displays/PersonCircleXMarkIcon";
import { yyyyMMdd } from "../../constant";
import { getFullName } from "../../utils/format";
import { PatientHyperlink } from "../Displays/PatientHyperlink";
import { BigText } from "../Displays/BigText";

export type PatientNameCommonProps = {
  patient?: IPatientResponse;
  showIcon?: boolean;
  dateFormat: string;
  className?: string;
  onClick?: (e) => void;
  isHyperLink?: boolean;
  isDark?: boolean;
};

export const PatientName: FC<PatientNameCommonProps> = ({
  patient,
  showIcon = true,
  dateFormat,
  className = "",
  onClick,
  isHyperLink = false,
}) => {
  const fullName = getFullName(patient);
  return (
    <span
      title={fullName}
      className={`no-wrap d-flex ${className} ${
        onClick ? "cursor-pointer" : ""
      }`}
      onClick={onClick}
    >
      {showIcon && (
        <PersonCircleXMarkIcon
          show={patient?.deceased || !!patient?.deceasedAt || false}
          deceasedAt={patient?.deceasedAt}
          dateFormat={dateFormat || yyyyMMdd}
        />
      )}
      {isHyperLink && (
        <PatientHyperlink
          href={`/Patients/${patient?.id}`}
          text={fullName}
          maxWidth={"100%"}
          className="hyperlink"
        />
      )}

      {!isHyperLink && <BigText text={fullName} maxWidth={"100%"} />}
    </span>
  );
};
